import { Answer } from '../answer/answer.model';
import { OnInteraction } from './on-interaction.model';
import { AnswerMapper } from '../../answer-mapper';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class AnswersSelfExam extends OnInteraction {
  public answer?: Answer;

  public isCorrect: boolean;

  constructor(isCorrect: boolean, answer: Answer | undefined) {
    super();
    this.answer = answer;
    this.isCorrect = isCorrect;
  }

  public static fromDto(dto: any): AnswersSelfExam {
    return new AnswersSelfExam(
      dto.isCorrect,
      dto.answer ? AnswerMapper.fromDto(dto.answer) : undefined,
    );
  }
}
